<template>
  <div class="h-100">
    <template v-if="dataTableReady">
      <datatable
        :tcols="cols"
        :trows="rows"
        :tconfig="config"
        :pages_chunk="pages_chunk"
        :rows_count="rows_count"/>
    </template>
    <template v-else>
      <loader/>
    </template>
  </div>
</template>
<script>
import datatable from '@/components/datatable'
import axios from '../axios'
import _ from 'lodash'
import loader from '@/components/loader'

export default {
  components: {datatable, loader},

  // created () {},
  name: 'TableController',
  mounted() {
   // this.appendData()

  },

  watch: {
    '$route.name': {
      handler: function (name) {
        this.dataTableReady = false
        this.appendData()
      },
      deep: true,
      immediate: true
    },
  },

  data: function () {
    return {
      dataTableReady: false,
      cols: [],
      rows: [],
      rows_count: 0,
      config: {},
      options: {},
      is_loading: false,
      pages_chunk: 25,
      page_p: 1,
      query_params: false,
    }
  },

  methods: {
    appendData() {



      import('../table-config').then((config) => {
          let tconfig = config.default[this.$route.name]
          if (tconfig) {
            this.config = tconfig
          } else {
            this.config = {}
          }
        })

        let showTable;

        // if we have filters params in the url
        // kobi -> always true! to always use insuranceCompanyFilter 2/3/22
        if (true || this.$route.query['ins_type'] || this.$route.query['company'] || this.$route.query['protective_status'] || this.$route.query['lack_of_claims']) {

          // const urlParams = new URLSearchParams(window.location.search)
          // let url_page = '';
          // if (urlParams.get('page')) {
          //   url_page = "/" + urlParams.get('page');
          // }

          let url_page = '';
          if (this.$route.query['page']) {
            url_page = "/" + this.$route.query['page'];
          }

          // if (this.$route.query['ins_type']
          //   || this.$route.query['company']
          //   || this.$route.query['protective_status']
          //   || this.$route.query['lack_of_claims']) {
          //   url_page = "/1";
          //   this.page_p = 1;
          //   urlParams.set('page', '1')
          // }



          let ordersPages = ['orders', 'ordersControl', 'ordersProtect', 'ordersCancellations', 'ordersCollection', 'ordersTasks', 'ordersClaims']

          let url = ordersPages.includes(this.$route.name) ? 'insuranceCompanyFilter': 'all'
          const routeName = ordersPages.includes(this.$route.name) ? 'orders' : this.$route.name;

          let data = this.$route.query;

          if(!data.pages_chunk){
            data.pages_chunk = 25;
            data.routeName = this.$route.name;
          }

          if (data) {
            axios.post(`/${routeName}/${url}${url_page}`, data)
              .then((res) => {
                const resData = res.data.data.rows;
                let resKeys
                if (!_.isObject(resData[0])) {
                  resKeys = resData
                } else {
                  resKeys = Object.keys(resData[0])
                }


                // resKeys.unshift('#')
                if (!this.config.readonly) {
                  resKeys.unshift('actions')
                }
                if (routeName  === 'orders') {
                  resKeys = _.without(resKeys, 'userId', 'updated_at')
                } else {
                  resKeys = _.without(resKeys, 'userId', 'updated_at')
                }


                this.cols = resKeys



                if (_.isObject(resData[0])) {
                  this.rows = resData
                } else {
                  this.rows = []
                }

                this.config['options'] = new Array()

                if ('total_rows' in res.data.data.options) {
                  this.rows_count = res.data.data.options.total_rows;
                }

                let options = res.data.data.options;
                if (options) {
                  for (let i in options) {
                    this.config['options'][i] = options[i]
                  }
                }
                showTable = true
              })
              .catch((err) => {
                console.log(err)
                showTable = true
                this.$emit('alert', 'danger', this.$t('message.tableNotFound'))
                /*setTimeout(() => {
                  window.location.href = this.$route.name;
                }, 2000)*/
              })
              .finally(() => {
                this.dataTableReady = showTable
              })
          }
        } else {


            this.is_loading = true
            const urlParams = new URLSearchParams(window.location.search)
            let url_page = '';
            if (urlParams.get('page')) {
              url_page = "/" + urlParams.get('page');
            }

            axios.get(`/${this.$route.name}/all${url_page}`)
              .then((res) => {

                const resData = res.data.data.rows;

                let resKeys
                if (!_.isObject(resData[0])) {
                  resKeys = resData
                } else {
                  resKeys = Object.keys(resData[0])
                }


                // resKeys.unshift('#')
                if (!this.config.readonly) {
                  resKeys.unshift('actions')
                }
                if (this.$route.name === 'orders') {
                  resKeys = _.without(resKeys, 'userId', 'updated_at')
                } else {
                  resKeys = _.without(resKeys, 'userId', 'updated_at')
                }


                this.cols = resKeys

                if (_.isObject(resData[0])) {
                  this.rows = resData
                } else {
                  this.rows = []
                }

                this.config['options'] = new Array()

                if ('total_rows' in res.data.data.options) {
                  this.rows_count = res.data.data.options.total_rows;
                }

                let options = res.data.data.options;
                if (options) {
                  for (let i in options) {
                    if (i === 'allStatuses') {
                      setTimeout(() => {
                        if (this.config['options'][i]) {
                          for (let k in this.config['options']['allStatuses']) {
                            this.config['options']['allStatuses'][k].value = this.config['options']['allStatuses'][k].value + ' - ' + `(${this.config['options']['allStatuses'][k].statusGroup})`
                          }
                        }
                      }, -1)
                    }
                    this.config['options'][i] = options[i]
                  }
                }
                // console.log(this.config);
                // Only for messages modal - we concat status group with status name
                /*if (this.$route.name ==='messages') {
                for (let i in this.options.allStatuses) {
                  this.options.allStatuses[i].value = this.options.allStatuses[i].value + ' - ' + `(${this.options.allStatuses[i].statusGroup})`
                }
              }*/
                // console.log(this.config)
                showTable = true
              })
              .catch((err) => {
                console.log(err)
                showTable = false
                this.$emit('alert', 'danger', this.$t('message.tableNotFound'))
              })
              .finally(() => {
                this.dataTableReady = showTable
                this.is_loading = false
              })


        }
      }



  }
}
</script>
